import { wrapFunction } from '../utils';

export const CONTAINS = (value: string | Array<unknown>, needle: string | unknown): boolean => {
    if (typeof value === 'string') {
        if (typeof needle !== 'string') {
            throw new Error('CONTAINS expects its second argument to be a string');
        }
        return value.includes(needle);
    }

    if (Array.isArray(value)) {
        return value.includes(needle);
    }

    throw new Error('CONTAINS expects its first argument to be a string or an array');
};

export default wrapFunction(CONTAINS, {
    name: 'CONTAINS',
    nargs: 2,
    types: ['any', 'any'],
});
